import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  padding: 30px 15px;

  border-radius: 4px;

  background-color: #d4f2ff;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 4px 4px rgba(0, 0, 0, 0.06),
    1px 4px 6px rgba(0, 0, 0, 0.16);
`;

export { Container };
